module.exports = __webpack_public_path__ + "static/tanner-2e8e6add23c6e0df8cf562149f222d81.jpg";